const shippingEn = {
  "settings.shipping": "Shipping & delivery",
  "settings.shipping_hint": "Rates, local delivery, pickup in store and packages",
  "ship.title": "Shipping and delivery",
  "ship.test": "Test your rates",
  "ship.test_run": "Get rates",
  "ship.test_hint": "See what a customer would be offered at checkout for these products and this address.",
  "ship.test_cart": "Products",
  "ship.test_result": "Customers see",
  "ship.add_products": "Add products",
  "ship.cant_ship": "Can't ship",
  "ship.country": "Country/region",
  "ship.qa_zone": "Zone number",
  "ship.zip": "Postal code",
  "ship.coordinates": "Map location",
  "ship.coordinates_hint": "Latitude and longitude, for local delivery by distance or drawn area.",
  "ship.no_shipping_needed": "Nothing in this cart needs shipping.",
  "ship.no_options": "Customers can't check out to this address: no rate, delivery area or pickup location covers it.",
  "ship.delivery_minimum": "Local delivery reaches this address from orders of {amount}.",
  "ship.kind.shipping": "Shipping",
  "ship.kind.local_delivery": "Local delivery",
  "ship.kind.pickup": "Pickup",
  "ship.free": "Free",
  "ship.km_away": "{n} km away",
  "ship.nothing_set": "Customers can't check out yet: add a shipping rate, local delivery or pickup in store.",
  "ship.shipping": "Shipping",
  "ship.shipping_hint": "Choose where you ship and how much you charge. Products are in the General profile unless you move them to a custom profile.",
  "ship.create_profile": "Create custom profile",
  "ship.create_profile_hint": "Custom profiles give some products their own rates, like large or fragile items.",
  "ship.create": "Create",
  "ship.general": "General shipping rates",
  "ship.general_products": "All products not in other profiles ({n})",
  "ship.general_products_hint": "To give products different rates, add them to a custom profile.",
  "ship.products_count": "{n} products",
  "ship.custom_rates": "Custom shipping rates",
  "ship.no_zones": "No shipping zones",
  "ship.zones_summary": "{zones} · {n} rates",
  "ship.no_rates": "No rates",
  "ship.local_delivery": "Local delivery",
  "ship.local_delivery_hint": "Deliver orders yourself to customers nearby.",
  "ship.offers_delivery": "Offers delivery",
  "ship.no_delivery": "Doesn't offer delivery",
  "ship.pickup": "Pickup in store",
  "ship.pickup_hint": "Let customers pick up their orders at your locations.",
  "ship.offers_pickup": "Offers pickup",
  "ship.no_pickup": "Doesn't offer pickup",
  "ship.packages": "Packages",
  "ship.packages_hint": "The boxes and envelopes you ship in, for shipping labels.",
  "ship.add_package": "Add package",
  "ship.edit_package": "Edit package",
  "ship.no_packages": "No packages yet.",
  "ship.default": "Default",
  "ship.delete_package": "Delete {name}?",
  "ship.pkg.box": "Box",
  "ship.pkg.envelope": "Envelope",
  "ship.pkg.soft_package": "Soft package",
  "ship.pkg.length": "Length",
  "ship.pkg.width": "Width",
  "ship.pkg.height": "Height",
  "ship.pkg.unit": "Unit",
  "ship.pkg.weight": "Weight when empty (kg)",
  "ship.pkg.weight_hint": "Added to the products' weight on labels.",
  "ship.pkg.name": "Package name",
  "ship.pkg.default": "Use as the default package",
  "ship.location_inactive": "This location is inactive. Activate it in Settings → Locations first.",
  "ship.pickup_enable": "This location offers pickup in store",
  "ship.pickup_enable_hint": "Customers choose it at checkout and come to collect their order.",
  "ship.ready_time": "Expected pickup time",
  "ship.ready_time_hint": "Shown at checkout and in the order confirmation.",
  "ship.ready.1h": "Usually ready in 1 hour",
  "ship.ready.2h": "Usually ready in 2 hours",
  "ship.ready.4h": "Usually ready in 4 hours",
  "ship.ready.24h": "Usually ready in 24 hours",
  "ship.ready.2d": "Usually ready in 2–4 days",
  "ship.ready.5d": "Usually ready in 5 or more days",
  "ship.pickup_instructions": "Order ready for pickup notification",
  "ship.pickup_instructions_hint": "Instructions included in the email, like where to park or what to bring.",
  "ship.profile_name": "Profile name",
  "ship.profile_name_hint": "Customers won't see this.",
  "ship.profile_name_placeholder": "Fragile products",
  "ship.products": "Products",
  "ship.no_products": "No products yet. Products you add here leave the General profile.",
  "ship.variants_of": "{n} of {total} variants",
  "ship.group_n": "Location group {n}",
  "ship.shipping_rates": "Shipping rates",
  "ship.remove_group": "Remove group",
  "ship.add_group": "Create new location group",
  "ship.add_group_hint": "Use groups when locations ship to different places or at different rates.",
  "ship.shipping_from": "Shipping from",
  "ship.shipping_to": "Shipping to",
  "ship.manage": "Manage",
  "ship.no_locations": "Choose the locations that ship these products.",
  "ship.locations_hint": "Orders are fulfilled from these locations at these rates. A location is in one group of a profile.",
  "ship.inactive": "Inactive",
  "ship.in_other_group": "In another group",
  "ship.create_zone": "Create zone",
  "ship.edit_zone": "Edit zone",
  "ship.delete_zone_short": "Delete zone",
  "ship.delete_zone": "Delete the zone {name}?",
  "ship.delete_zone_body": "Its rates are deleted too when you save.",
  "ship.no_zones_hint": "Create a zone for the countries and regions you ship to.",
  "ship.zone_name": "Zone name",
  "ship.zone_name_hint": "Customers won't see this.",
  "ship.selected_countries": "Selected ({n})",
  "ship.search_countries": "Search countries and regions",
  "ship.rest_of_world": "Rest of world",
  "ship.in_other_zone": "In another zone",
  "ship.all_regions": "All regions",
  "ship.some_regions": "Some regions ({label})",
  "ship.regions_n": "{n} regions",
  "ship.zone_no_rates": "No rates: customers in this zone can't check out.",
  "ship.rate_name": "Rate name",
  "ship.rate_name_hint": "Customers see this at checkout.",
  "ship.condition": "Condition",
  "ship.price": "Price",
  "ship.price_hint": "Enter 0 for free shipping.",
  "ship.add_rate": "Add rate",
  "ship.edit_rate": "Edit rate",
  "ship.cond_and_up": "{v} and up",
  "ship.cond_up_to": "Up to {v}",
  "ship.free_over_short": "free over {v}",
  "ship.transit_time": "Transit time",
  "ship.transit.custom": "Custom (no transit time)",
  "ship.transit.economy": "5 to 8 business days",
  "ship.transit.standard": "3 to 4 business days",
  "ship.transit.express": "1 to 2 business days",
  "ship.transit_name.economy": "Economy",
  "ship.transit_name.standard": "Standard",
  "ship.transit_name.express": "Express",
  "ship.delivery_promise": "Delivery promise",
  "ship.delivery_promise_hint": "e.g. Same day if ordered before 2pm",
  "ship.free_over_toggle": "Free when the order reaches an amount",
  "ship.free_over": "Free for orders over",
  "ship.conditions": "Conditions",
  "ship.cond.flat": "None",
  "ship.cond.weight_based": "Based on item weight",
  "ship.cond.price_based": "Based on order price",
  "ship.min_price": "Minimum price",
  "ship.max_price": "Maximum price",
  "ship.min_weight": "Minimum weight",
  "ship.max_weight": "Maximum weight",
  "ship.no_limit": "No limit",
  "ship.delete_profile": "Delete {name}?",
  "ship.delete_profile_body": "Its products go back to the General profile and use its rates.",
  "ship.delete_profile_button": "Delete profile",
  "ship.local_delivery_for": "Local delivery: {name}",
  "ship.delivery_enable": "This location offers local delivery",
  "ship.delivery_enable_hint": "Customers in your delivery areas can choose local delivery at checkout.",
  "ship.delivery_area": "Delivery area",
  "ship.set_pin": "Pin location",
  "ship.move_pin": "Move pin",
  "ship.pin_hint": "Pin this location on the map to deliver by distance and show customers how far it is.",
  "ship.pin_mode": "Click the map where this location is, or drag the pin.",
  "ship.draw_mode": "Click the map to add the corners of {name}.",
  "ship.no_areas": "Add the areas you deliver to.",
  "ship.area.name": "Area name",
  "ship.area.radius": "Distance (km)",
  "ship.area.polygon": "Drawn area",
  "ship.area.codes": "Zone numbers or postal codes",
  "ship.area.codes_hint": "Postal codes, separated with commas. End with * for a prefix (e.g. 100*).",
  "ship.area.default_radius": "Within {n} km",
  "ship.area.default_polygon": "Area {n}",
  "ship.area.default_codes": "Zones {n}",
  "ship.area.price": "Delivery price",
  "ship.area.min_order": "Minimum order",
  "ship.area.free_over": "Free over",
  "ship.area.points": "{n} points",
  "ship.area.draw": "Draw on map",
  "ship.area.undo": "Undo point",
  "ship.area.clear": "Clear",
  "ship.area.add_radius": "Add distance area",
  "ship.area.add_polygon": "Draw an area",
  "ship.area.add_codes": "Add zones / postal codes",
  "ship.area.order_hint": "Areas are checked in this order: the first one that covers the address (and its minimum order) is used.",
  "ship.delivery_info": "Delivery information",
  "ship.checkout_instructions": "Checkout instructions",
  "ship.checkout_instructions_hint": "Shown to customers who choose local delivery.",
  "ship.schedule": "Delivery dates and times",
  "ship.schedule_hint": "Customers pick a slot at checkout. Without slots, delivery has no date choice.",
  "ship.slot.start": "From",
  "ship.slot.end": "To",
  "ship.slot.capacity": "Deliveries per slot",
  "ship.slot.capacity_hint": "The slot closes when full.",
  "ship.slot.add": "Add time slot",
  "ship.slot.none": "No time slots: customers don't choose a delivery time.",
  "ship.day.0": "Sun",
  "ship.day.1": "Mon",
  "ship.day.2": "Tue",
  "ship.day.3": "Wed",
  "ship.day.4": "Thu",
  "ship.day.5": "Fri",
  "ship.day.6": "Sat",
  "ship.cutoff": "Same-day cutoff",
  "ship.cutoff_hint": "Orders after this time can't get same-day delivery.",
  "ship.lead_days": "Days to prepare",
  "ship.lead_days_hint": "0 lets customers choose today.",
  "ship.days_ahead": "Days customers can book",
  "ship.days_ahead_hint": "How far ahead slots are shown.",
  "ship.blackout": "Days without delivery",
  "ship.blackout_hint": "Holidays and closures.",
  "ship.upcoming": "Upcoming slots",
} as const;

export default shippingEn;
